"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setupDirective(Vue, directiveName) {
    var trackDirective = {
        bind: function (el, binding) {
            el.addEventListener('click', function () {
                Vue.gtm.trackEvent(binding.value);
            });
        },
    };
    Vue.directive(directiveName || 'track', trackDirective);
}
exports.setupDirective = setupDirective;
//# sourceMappingURL=directive.js.map